

























import Vue from 'vue';

export default Vue.extend({
  name: `Openinghours`,
  computed: {
    phoneNumberDigits(): string {
      return this.$t(`footer:openingHours.phone`).replace(`(0)`, ``).replace(/[^0-9.]/g, ``);
    },
  },
});
